import { TariffRateService } from '../../service/tariff-rate.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FacilityService } from 'src/app/core/services/facility.service';
import { SessionBaseComponent } from './../../../../shared/components/session.base.component';
import { Component, Injector, OnInit } from '@angular/core';
import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { DatePipe } from '@angular/common';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';

@Component({
  selector: 'laas-tariff-rate-setting-edit',
  templateUrl: './tariff-rate-setting-edit.component.html',
  styleUrls: ['./tariff-rate-setting-edit.component.scss']
})
export class TariffRateSettingEditComponent extends SessionBaseComponent implements OnInit {
  readonly permissionCode: PermissionConstants = PermissionConstants.ViewTariffRateSetting;

  tariffRate: any;
  editForm: FormGroup;
  forwarderOptions: any[];

  constructor(
    injector: Injector,
    private facilityService: FacilityService,
    private tariffRateService: TariffRateService,
    private formBuilder: FormBuilder,
    private datePipe: DatePipe
  ) {
    super(injector);
    this.forwarderOptions = [];
    this.tariffRate = {
      forwarder: '',
      sku: '',
      tariffRate: '',
      customsTariff: '',
      skuDescription: '',
      declarationDtTimeZone: '',
      brand: '',
      isActivated: '',
      startDtTimeZone: '',
      endDtTimeZone: '',
      createUser: '',
      createDt: '',
      updateUser: '',
      updateDt: ''
    };

    this.editForm = this.formBuilder.group({
      forwarder: '',
      sku: '',
      tariffRate: '',
      customsTariff: '',
      skuDescription: '',
      declarationDtTimeZone: '',
      brand: '',
      isActivated: '',
      startDtTimeZone: '',
      endDtTimeZone: '',
      createUser: '',
      createDt: '',
      updateUser: '',
      updateDt: ''
    });
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    const seqNo = this.routeStateService.getCurrent().data.seqNo;

    try{
      this.tariffRate = await this.tariffRateService.getTariffRateDetail(seqNo);
      this.tariffRate.declarationDtTimeZone = this.datePipe.transform(this.tariffRate.declarationDt, "yyyy/MM/dd", this.laasSetting.facilityTimeZone);
      this.tariffRate.startDtTimeZone = this.datePipe.transform(this.tariffRate.startDt, "yyyy/MM/dd", this.laasSetting.facilityTimeZone);
      this.tariffRate.endDtTimeZone = this.datePipe.transform(this.tariffRate.endDt, "yyyy/MM/dd", this.laasSetting.facilityTimeZone);
    }catch (err: any) {
      console.log('get tariff rate occur error: ' + JSON.stringify(err));
    }

    this.facilityService.getForwarderOptions(this.tariffRate.facility).subscribe({
      next: result => {
        this.forwarderOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    //rbac to maintain this page
    var canInPage = this.permissionCodes.includes(this.permissionCode);
    if (!canInPage) {
      //go unAuthorize
      this.routeStateService.navigateTo('/Error/unAuthorize');
    }
  }

  saveBtnClick(event: any): void{
    if (this.editForm.invalid) {
      this.toastService.warn('請檢查是否有必填欄位尚未填寫');
      return;
    }

    //DateTime convert
    this.tariffRate.declarationDt = isNullOrEmpty(this.tariffRate.declarationDtTimeZone) ? null : new Date(this.tariffRate.declarationDtTimeZone).toISOString();
    this.tariffRate.startDt = isNullOrEmpty(this.tariffRate.startDtTimeZone) ? null : new Date(this.tariffRate.startDtTimeZone).toISOString();
    this.tariffRate.endDt = isNullOrEmpty(this.tariffRate.endDtTimeZone) ? null : new Date(this.tariffRate.endDtTimeZone).toISOString();
    this.tariffRate.updateUser = this.userProfile.userName;

    this.tariffRateService.updateTariffRate(this.tariffRate).subscribe({
      next: result => {
        this.translateService.get('Common.Message.SuccessSave')
            .subscribe({
              next: msg => {
                this.toastService.success(msg);
                this.routeStateService.navigateTo('/Setting/TariffRateSetting', this.tariffRate);
              }
            });
      }
    });
  }

  goToLastPage(): void{
    this.routeStateService.loadPrevious();
  }
}
